import React, { useEffect, useState } from "react";
import {
  DocumentData,
  QueryDocumentSnapshot,
  QuerySnapshot,
  collection,
  deleteField,
  getDocs,
  getFirestore,
  onSnapshot,
  orderBy,
  query,
  updateDoc,
  where,
} from "firebase/firestore";

import ExperimentInformation from "./ExperimentInformation";
import { app, auth } from "../lib/firebase";
import "../lib/RequireUser/index.css";
import { addUserExperiment } from "../lib/controller";
import { NewProjectExperimentType } from "../Types/projectExperiment";
import { object } from "firebase-functions/v1/storage";
import { error } from "console";

function UserExperiment() {
  const db = getFirestore(app);

  const [prjExperiments, setPrjExperiments] = useState<
    NewProjectExperimentType[]
  >([]);
  var addedDocument: boolean = false;

  const tempUser = localStorage.getItem("userUID");

  const prjTitle = localStorage.getItem("projectTitle");
  const todayDate: string = DateToYYYYMMDD(new Date());
  //console.log("today is ", todayDate);

  if (!addedDocument) {
    preliminary();
  } else {
    console.log(" userExperiment entered and addedDocument = ", addedDocument);
  }
  //console.log(" after addedDoc check and before query");
  const q = query(
    collection(db, "projectExperiments"),
    where("experimentUserID", "==", tempUser),
    where("projectTitle", "==", prjTitle),
    orderBy("experimentDate", "desc")
  );

  //console.log(" after query and before useEffect and user id = ", tempUser);
  //console.log(" after query and before useEffect and prjTitle = ", prjTitle);
  useEffect(
    () =>
      onSnapshot(q, (snapshot) => {
        return setPrjExperiments(
          snapshot.docs.map((doc) => {
            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );
  //console.log(" after useEffect and before return/loading ");
  //console.log(" number of experiments is = ", prjExperiments.length);
  let expNum = String(prjExperiments.length);
  localStorage.setItem("expNum", expNum);
  //console.log(" prjExperiments ", prjExperiments[0]);
  //console.log(" prjExperiments ", prjExperiments.length);
  for (let i = 0; i < prjExperiments.length; i++) {
    console.log(
      " i = ",
      i,
      "signatureRequested = ",
      prjExperiments[i].signatureRequested
    );
    if (prjExperiments[i].signatureRequested === "no") {
      prjExperiments[i].requestSignature = "Reqest";
      prjExperiments[i].requestButtonDisabled = false;
    } else {
      prjExperiments[i].requestSignature = "Reqested";
      prjExperiments[i].requestButtonDisabled = true;
    }
  }
  return (
    <div>
      {prjExperiments && prjExperiments.length ? (
        <div>
          {prjExperiments?.map((prjExperiments) => (
            <ExperimentInformation
              key={prjExperiments.id}
              projectExperiment={prjExperiments}
            />
          ))}
        </div>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );

  function DateToYYYYMMDD(date: Date) {
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let monthString = month.toString();
    if (month < 10) {
      monthString = "0" + monthString;
    }
    let day = date.getDate();
    let dayString = day.toString();
    if (day < 10) {
      dayString = "0" + dayString;
    }
    let dateString = `${year}/` + monthString + "/" + dayString;
    return dateString;
  }

  //Need to add to the query the project title passed by ExperimentProjectSelection
  async function preliminary() {
    var qProject = query(
      collection(db, "projectExperiments"),
      where("experimentUserID", "==", tempUser),
      where("experimentDate", "==", todayDate),
      where("projectTitle", "==", prjTitle)
    );
    console.log("date converted is ", todayDate);

    //console.log("user is ", tempUser);
    //console.log("project is ", prjTitle);
    //console.log("qProject is ", qProject);

    const querySnapshot = await getDocs(qProject);

    //console.log("query snapshot docs in userExperiment = ", querySnapshot);
    //console.log(" empty method = ", querySnapshot.empty);

    if (querySnapshot.empty && !addedDocument) {
      //Create new experiment document
      addedDocument = true;
      //console.log(
      //  "in UserExperiment and calling addUserExperiment addedDocument = ",
      //  addedDocument
      //);
      const newExperiment = await addUserExperiment({
        aim: "",
        collaborator: "none",
        commentsAndAnalysis: "",
        //dataDescription: "",
        //dataURL: "",
        //dataShare: "no",
        experimentData: new Array<object>(),
        experimentDate: todayDate,
        experimentTitle: "",
        experimentUserID: tempUser,
        methodology: "",
        nextSteps: "",
        pdfFileURL: "",
        projectTitle: prjTitle,
        protocolNameDateVersion: "",
        results: "",
        signatureRequested: "no",
        signed: "no",
      });
      //console.log(
      //  "in UserExperiment following addUserExperiment and newExperiment = ",
      //  newExperiment
      //);
    }
  }
}

export default UserExperiment;
